import React from 'react';
import '../MyStoryPage/Styles.css'
import ContactSection from '../../components/ContactSectionPage/Index';
import useTitle from '../../useTitle';

const MyStory = () => {
    useTitle("My Story")
  return (
    <>
    <div className='aboutMeSection'>
        <div className='aboutMeInfo'>
            <div className='aboutMeInfoSection'>
                <div className='aboutMeTitleSection'>
                    <h1 className='aboutMeTitle'>My Story</h1>
                </div>
                <div className='aboutMeDescriptionSection'>
                    <p>After a career at sea I decided to take a four year evening class in goldsmithing.</p>
                    <p>After completing the first year i wanted to proceed as dedicated as possible, so i installed a basic workshop at home and started practicing and creating as much as possible.</p>
                    <p>The following year i had the amazing opportunity to start a one year apprenticeship on a 1 day a week basis in the workshop of Antwerp based goldsmith, Arvid Vantornout, a big leap into the craft and great experience.</p>
                    <p>Now, I proudly present you my handcrafted jewelry and I hope you enjoy wearing it as much as i did creating it.</p>
                    <p>Kind regards,</p>
                    <p>Rico</p>
                </div>
            </div>
        </div>
    </div>
    <ContactSection />
    </>
  )
}

export default MyStory;
